import DOM from '../../utils/dom';
import {CELL_CONTAINER_SELECTOR, CELL_CLASS_LIST, CELL_CONTENT_CLASS, CELL_CONTENT_BAR_CLASS, DAYS_LEFT_HEADER_SELECTOR} from "./temp_account_const";
import {TEMP_ACCOUNT_STATUS} from "../../services/regulation/regulation_const";
import BaseComponent from '../../base/base_component';
import { BaseComponentParams } from '../../base/base_component_interface';

const componentDaysView = require('./view/temp_account_days.html');
const componentVerifyView = require('./view/temp_account_verify.html');


export interface TempAccountComponentParams extends BaseComponentParams {

	status: string;

	daysLeft: number;

	messageText: string;

	footerMessageText?: string;

	hideDaysLeft: boolean;
}

export default class TempAccountComponent extends BaseComponent {
	/**
	 * @static
	 */
	static CLASS = 'TempAccountComponent';


	/**
	 *
	 * @type {TempAccountModel}
	 * @private
	 */
	protected _params : TempAccountComponentParams = null;


	/**
	 * @param params
	 */
	init(params: TempAccountComponentParams) {
		super.init(params);
		this._params = params;
	}

	start(): TempAccountComponent {
		const view = this._getView();
		if (!view) {
			this.logger.error('Status parameter is not defined, unable to create specified view');
			return this;
		}
		const bakedHTML = this.bake(view, {
			message: this._params.messageText,
			footerMessage: this._params.footerMessageText? this._params.footerMessageText : ''
		});
		this.setHTML(bakedHTML);
		
		if (this._params.hideDaysLeft) {
			const daysLeftEl = this.querySelector(DAYS_LEFT_HEADER_SELECTOR);
			DOM.removeElement(daysLeftEl.parentElement, daysLeftEl);
		}

		if (this._params.status === TEMP_ACCOUNT_STATUS.DOCUMENTS_NOT_RECEIVED
			&& !this._params.hideDaysLeft) {
           	this._addDaysLeft();
		}

		return this;
	}


	private _getView() {
		const status = this._params.status;
		let view: string = '';
		switch (status) {
			case TEMP_ACCOUNT_STATUS.PENDING_VERIFICATION:
                view = componentVerifyView;
				break;
			case TEMP_ACCOUNT_STATUS.DOCUMENTS_NOT_RECEIVED:
				view = componentDaysView;
				break;
			default:
				break;
		}
		return view;
	}



	private _addDaysLeft() {
		const cellContainer = this.getEl().querySelector(CELL_CONTAINER_SELECTOR);
		const cellContents = this._params.daysLeft.toString().split('');
		const cellNo = cellContents.length;

		for(let i = 0; i < cellNo; i++) {
			DOM.append(cellContainer, this._getCell(cellContents[i]));
		}
	}


	private _getCell(content) {
		const cell = DOM.createElement('div'),
			cellContent = DOM.createElement('div', content),
			contentBar = DOM.createElement('div');

		DOM.append(cell, cellContent)
		   .append(cell, contentBar)
		   .addClass(cell, CELL_CLASS_LIST)
		   .addClass(cellContent, CELL_CONTENT_CLASS)
		   .addClass(contentBar, CELL_CONTENT_BAR_CLASS);

		return cell;
	}
}